<div class="relative w-full">
  <img src="/notice/notice-bg-mo.png" alt="top background" class="w-full flex lg:hidden" />
  <img src="/notice/notice-bg-pc.png" alt="top background" class="w-full hidden lg:flex" />

  <div class="absolute inset-0 flex flex-col justify-center gap-3 pt-14 px-4 lg:px-0 lg:container">
    <h1 class="text-white text-2xl lg:text-4xl font-bold">공지사항</h1>
    <p class="text-zinc-300 font-medium">Notice</p>
  </div>
</div>

<div class="flex flex-col px-4 gap-6 lg:px-0 lg:max-w-6xl lg:mx-auto py-6 lg:py-12 w-full">
  @if (data(); as notice) {
  <!-- 목록으로 버튼 -->
  <button routerLink=".." class="cursor-pointer flex items-center gap-1 hover:text-zinc-600 transition-colors w-fit">
    <app-icon name="mdi:chevron-left" class="size-5! text-zinc-300" />
    <span class="text-zinc-400 font-medium">목록으로</span>
  </button>

  <div class="flex flex-col gap-3">
    <h1 class="text-xl lg:text-2xl text-zinc-800 font-semibold lg:font-bold">{{ notice.title }}</h1>
    <div class="text-sm text-zinc-400 font-medium">
      {{ notice.displayDate || notice.createdAt | date : 'yyyy-MM-dd HH:mm' }}
    </div>
  </div>

  <div class="w-full h-px bg-zinc-100"></div>

  <!-- 본문 영역 -->
  <div
    class="editor-content prose prose-zinc max-w-none prose-headings:font-normal prose-p:text-zinc-700 prose-p:leading-relaxed prose-li:text-zinc-700"
    [innerHTML]="notice.content | safeHtml"></div>

  <!-- 첨부파일 영역 -->
  @if (files().length > 0) {
  <div class="flex flex-col gap-3">
    @for (file of files(); track file.id) {
    <app-file-download [url]="file.url" [filename]="file.name" [size]="file.size" variant="notice" />
    }
  </div>
  }

  <!-- 이전글/다음글 영역 -->
  <div class="flex flex-col border-y border-zinc-100">
    <!-- 이전글 -->
    @if (prevNotice(); as prev) {
    <div
      [routerLink]="['..', prev.id]"
      class="flex items-center gap-3 p-6 border-b border-zinc-100 hover:bg-zinc-50 transition-colors cursor-pointer">
      <span class="text-sm text-zinc-400 font-medium shrink-0"> 이전글 </span>
      <span class="text-sm text-zinc-800 font-medium flex-1 truncate">
        {{ prev.title }}
      </span>
      <span class="text-sm text-zinc-400 shrink-0 font-medium">
        {{ prev.displayDate || prev.createdAt | date : 'yyyy.MM.dd' }}
      </span>
    </div>
    } @else {
    <div class="flex items-center gap-3 p-6 border-b border-zinc-100">
      <span class="text-sm text-zinc-400 font-medium shrink-0"> 이전글 </span>
      <span class="text-sm text-zinc-400 flex-1"> 이전 글이 없습니다. </span>
    </div>
    }

    <!-- 다음글 -->
    @if (nextNotice(); as next) {
    <div
      [routerLink]="['..', next.id]"
      class="flex gap-3 items-center p-6 hover:bg-zinc-50 transition-colors cursor-pointer">
      <span class="text-sm text-zinc-400 font-medium shrink-0"> 다음글 </span>
      <span class="text-sm text-zinc-800 font-medium flex-1 truncate">
        {{ next.title }}
      </span>
      <span class="text-sm text-zinc-400 shrink-0 font-medium">
        {{ next.displayDate || next.createdAt | date : 'yyyy.MM.dd' }}
      </span>
    </div>
    } @else {
    <div class="flex items-center gap-3 p-6">
      <span class="text-sm text-zinc-400 font-medium shrink-0"> 다음글 </span>
      <span class="text-sm text-zinc-400 flex-1"> 다음 글이 없습니다. </span>
    </div>
    }
  </div>

  <!-- 하단 목록으로 버튼 -->
  <div class="flex justify-center">
    <button
      routerLink=".."
      class="cursor-pointer w-full lg:w-[30%] py-2 border border-zinc-200 text-zinc-800 rounded-lg font-medium">
      목록으로
    </button>
  </div>
  }
</div>
